<script setup>
const props = defineProps({
  page: {
    type: Object,
    required: true,
  },
})

const bodyComponents = useBodyComponents(props.page)
</script>

<template>
  <div
    v-for="iComponent in bodyComponents"
    :key="iComponent.data.id"
    class="component-wrapper"
    :class="{
      'component-wrapper--hero': iComponent.data.type === 'hero_block',
      'component-wrapper--recipe': iComponent.data.type === 'recipe_preparation_block',
    }"
  >
    <component
      :is="iComponent.component"
      v-bind="iComponent.data.value"
    />
  </div>
</template>

<style lang="scss">
@import '~/assets/scss/variables.scss';
@import 'bootstrap/scss/mixins';

.component-wrapper {
  margin-bottom: clamp(80px, 4.17vw + 66.67px, 140px);

  &--hero {
    margin-bottom: 0;

    @include media-breakpoint-down(880) {
      margin-bottom: 60px;
    }
  }
}
.component-wrapper--recipe ~ .component-wrapper--recipe {
  margin-top: -60px;
}
</style>
